import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import { Title, Section, Box, LinkContact, Text } from '../../components/Core'
//import bhHero from './tiles2.png'
import algolia from './images/algolia.png'
import gatsby from './images/gatsby.png'
import forest from './images/forest.png'
import googlecloud from './images/googlecloud.png'
import stripe from './images/stripe.png'
import mobile from './images/mobile.png'
import mysql from './images/mysql.png'
import google from './images/google.png'
import salesforce from './images/salesforce.png'
import twilio from './images/twilio.png'
import react from './images/react.svg'
import redux from './images/redux.svg'
import symfony from './images/symfony.png'
import docker from './images/docker.png'
import elastic from './images/elastic.svg'
import aws from './images/aws.png'
import yarn from './images/yarn.svg'
import sass from './images/sass.svg'

const icons = {
    algolia,
    gatsby,
    forest,
    googlecloud,
    stripe,
    mobile,
    mysql,
    google,
    salesforce,
    twilio,
    react,
    redux,
    symfony,
    docker,
    elastic,
    aws,
    yarn,
    sass
}
const Img = props => <img {...props} />

const ColStyled = styled(Col)``
const ImgStyled = styled(Img)`
    height: 36px;
    margin-right: 15px;
`
const FlexBox = styled(Box)`
    display: flex;
    flex-justify: center;
    align-items: center;
`

const Key = ({ name, title, children, left = false }) => {
    const direction = left ? 'pr-lg-5' : 'pl-lg-5'
    return (
        <ColStyled lg="6" className={`mb-5 ${direction}`}>
            <FlexBox className="mb-4">
                <ImgStyled src={icons[name]} alt={name} />
                <Title variant="cardBig" className="mb-0">
                    {title}
                </Title>
            </FlexBox>

            <Text variant="p">{children}</Text>
        </ColStyled>
    )
}

const SectionStyled = styled(Section)`
    overflow: hidden;
    possition: relative;
`

const Keys = ({ children, ...props }) => {
    return (
        <>
            <SectionStyled className={`position-relative pt-0 pb-0`} {...props}>
                <Container>
                    <Title variant="secSm" className="mb-5 pb-lg-4">
                        Key Developments
                    </Title>
                    <Row>{children}</Row>
                </Container>
            </SectionStyled>
        </>
    )
}

export { Keys, Key }
